import React, { useEffect } from 'react'
import isEmpty from 'lodash/isEmpty';

// Redux 
import { useDispatch, useSelector } from 'react-redux'
import { userLogout } from '../../../../store/actions/user';
import { getPastReviews } from '../../../../store/actions/pastReviews';

// Components
import GeneralLoader from '../../../GeneralLoader';
import ErrorWrap from '../../../utils/error-success/ErrorWrap';


const PastReviewsFormSection = ({id}) => {
    const dispatch = useDispatch();
    const {
        pastReviewsLoading, pastReviewsError, pastReviews
    } = useSelector(state => state.pastReviews);


    useEffect(() => {
        // Fetch managers from API and store into state 
        dispatch(getPastReviews(id)).then((resp) => {
            if (resp.data.status === 403) {
                dispatch(userLogout("admin"));
                return;
            }
        })
    }, [])

    return (
		<div className="fieldset">
			<div className="title-label">Past Reviews</div>

			{pastReviewsLoading ? <GeneralLoader/> :
				<React.Fragment>

					{!!pastReviewsError && (
						<ErrorWrap animate={1}>{pastReviewsError.general}</ErrorWrap>
					)}

					{isEmpty(pastReviews) ? <div>This reviewer has no past reviews.</div>
						: pastReviews.map(item => (
							<div className='pb1'>{`${item.organization_title} (${item.city}, ${item.province}) - ${item.site_visit_starts}`}</div>
						))
					}

				</React.Fragment>
			}
		</div>
    )
}

export default PastReviewsFormSection


// WEBPACK FOOTER //
// ./src/components/admin/reviewers/form-components/PastReviewsFormSection.js